export enum GenerationStep {
    ANALYZING = 'analyzing',
    SEARCH = 'search',
    CORRELATING = 'correlating',
    PREPARING = 'preparing',
    FINALIZING = 'finalizing'
}

export const GENERATION_STEPS = [
    GenerationStep.ANALYZING,
    GenerationStep.SEARCH,
    GenerationStep.CORRELATING,
    GenerationStep.PREPARING,
    GenerationStep.FINALIZING
];

export const GENERATION_STEPS_PROGRESS_MAP: Record<GenerationStep, [number, number]> = {
    [GenerationStep.ANALYZING]: [-Infinity, 0.05],
    [GenerationStep.SEARCH]: [0.05, 0.2],
    [GenerationStep.CORRELATING]: [0.2, 0.4],
    [GenerationStep.PREPARING]: [0.4, 0.6],
    [GenerationStep.FINALIZING]: [0.6, Infinity]
};
